export function formatAmount(v: number | null) {
    return (v !== null && v !== 0) ? new Intl.NumberFormat("md-MD").format(v) : "-"
}

export function formatQuantity(v: number | null) {
    return (v !== null && v !== 0) ? v : "-"
}